import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import { isAuthenticatedUser } from 'js/lib/user';

import AdminPermission from 'bundles/admin/utils/AdminPermission';
import type { AdminUserPermissionsQuery } from 'bundles/degree-home/utils/__generated__/AdminUserPermissionsQuery';

const adminUserPermissionsQuery = gql`
  query AdminUserPermissionsQuery {
    AdminUserPermissionsV1Resource {
      my {
        elements {
          id
          permissions
        }
      }
    }
  }
`;

const useDegreeHomeAdminPermissions = () => {
  const { data: adminPermissionData, loading: adminPermissionDataLoading } = useQuery<AdminUserPermissionsQuery, {}>(
    adminUserPermissionsQuery,
    {
      skip: !isAuthenticatedUser(),
      errorPolicy: 'all',
    }
  );

  const adminPermissions =
    adminPermissionData?.AdminUserPermissionsV1Resource?.my?.elements?.[0]?.permissions &&
    new AdminPermission(adminPermissionData?.AdminUserPermissionsV1Resource?.my?.elements?.[0]?.permissions);

  return { adminPermissions, adminPermissionDataLoading };
};

export default useDegreeHomeAdminPermissions;
